import React from "react";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import MyShoppingCart from "./MyShoppingCart";
import PatitentDetailsN from "./PatitentDetailsN";
import PayN from "./PayN";

function Cart() {

    return(
        <>

        <div className="container">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav className="cartNav">
                    <Nav.Item>
                    <Nav.Link eventKey="first">my shopping cart</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                    <Nav.Link eventKey="second">patient details</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                    <Nav.Link eventKey="third">pay</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <MyShoppingCart/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                       <PatitentDetailsN/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                       <PayN/>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>

        </>
    )
}

export default Cart;